// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2256":"2364484e","5133":"f3a5f803","7404":"f3a5f803","8688":"c979e12a"}[chunkId] + ".chunk.css";
};